/**
 * Frete grátis por UF — davida alimentos
 * -----------------------------------------------------------------------------
 * Duas responsabilidades:
 *
 *   1. Aplicar a UF em vigor em TODAS as <free-shipping-bar> da página: topbar,
 *      gaveta do carrinho e página do carrinho.
 *
 *   2. Manter o estado visual da barra (padrão / falta pouco / atingido), que o
 *      tema não conhece — ele só tem duas mensagens e nenhuma classe de estado.
 *
 * Não redesenha nada: o custom element do tema (theme.js) já observa os atributos
 * "threshold" e "total-price". Setar "threshold" dispara o attributeChangedCallback,
 * que atualiza o valueMax da progress-bar e reescreve a mensagem.
 *
 * ---------------------------------------------------------------------------
 * COMO A UF É DECIDIDA (cascata, do mais confiável para o menos)
 * ---------------------------------------------------------------------------
 *
 *   1. manual   — o visitante escolheu no seletor. Vence sempre e nunca é
 *                 sobrescrita por nada abaixo.
 *   2. cliente  — endereço padrão de quem está logado, resolvido no servidor
 *                 pelo Liquid. Exato, de graça, sem terceiro.
 *   3. ip       — chute, e só se ligado no editor. Ver tentarPorIp().
 *   4. padrão   — a UF configurada na section (SP).
 *
 * O cookie guarda "UF|origem" justamente para o nível 3 nunca passar por cima
 * de uma escolha de gente.
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'davida_frete_uf';
  var IP_ENDPOINT = 'https://ipwho.is/';
  var IP_TIMEOUT_MS = 1500;

  /**
   * Operadoras de celular. No 4G/5G o tráfego sai por poucos pontos de presença
   * (CGNAT), então o IP aponta para o estado da operadora e não o do cliente —
   * tipicamente SP. Como a barra promete frete grátis, errar para BAIXO é o pior
   * caso possível: o cliente monta o carrinho e leva frete no checkout.
   *
   * O filtro é deliberadamente conservador: Claro, Vivo e Oi também vendem banda
   * larga fixa, e esses clientes caem fora junto. Perder cobertura só devolve a
   * pessoa para a UF padrão — o mesmo que aconteceria sem detecção nenhuma.
   */
  var OPERADORAS_MOVEIS = /\b(VIVO|TELEFONICA|CLARO|TIM|NEXTEL|ALGAR|AMERICEL|TELEMAR|OI\s+M[OÓ]VEL)\b/i;

  var configElement = document.getElementById('frete-regional-config');

  if (!configElement) return;

  var config;

  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  if (!config.ufs || config.ufs.length === 0) return;

  var currentUf = null;
  var isApplying = false;

  // ---------------------------------------------------------------------------
  // Cookie
  // ---------------------------------------------------------------------------

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax; Secure';
  }

  /**
   * Único ponto que consome o cookie. Sigla que não existe mais na configuração
   * devolve null e cai no padrão — é o que protege contra cookie adulterado ou
   * sobrevivente de uma faixa que mudou no editor.
   */
  function readState() {
    var raw = readCookie(COOKIE_NAME);

    if (!raw) return null;

    var parts = raw.split('|');
    var uf = ufByCode(parts[0]);

    if (!uf) return null;

    return { uf: uf, origem: parts[1] || 'manual' };
  }

  function writeState(uf, origem) {
    writeCookie(COOKIE_NAME, uf.s + '|' + origem, config.cookieDays);
  }

  // ---------------------------------------------------------------------------
  // UFs
  // ---------------------------------------------------------------------------

  function ufByCode(code) {
    if (!code) return null;

    var alvo = String(code).toUpperCase().replace(/[^A-Z]/g, '');

    for (var i = 0; i < config.ufs.length; i++) {
      if (config.ufs[i].s === alvo) return config.ufs[i];
    }

    return null;
  }

  function ufPadrao() {
    return ufByCode(config.defaultUf) || ufByCode(config.initialUf) || config.ufs[0];
  }

  // ---------------------------------------------------------------------------
  // Mensagens
  // ---------------------------------------------------------------------------

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /**
   * Espelha snippets/frete-msg.liquid. As duas implementações precisam produzir o
   * MESMO HTML, senão a mensagem "pula" entre o primeiro render e o primeiro update.
   *
   * Ordem: escape → [uf]/[regiao] → *negrito* → [valor]. O [valor] vira o token {{ }}
   * que o _updateMessage() do tema procura, e por isso entra depois do escape.
   *
   * [regiao] continua aceito como sinônimo de [uf] para não quebrar texto já salvo
   * no editor de temas.
   *
   * Aqui só um nível de escape, porque setAttribute não passa por parsing de atributo.
   * No Liquid são dois: um lá e um no limite do atributo HTML.
   */
  function formatMessage(text, sigla) {
    var safe = escapeHtml(text)
      .split('[uf]').join(escapeHtml(sigla))
      .split('[regiao]').join(escapeHtml(sigla));

    var chunks = safe.split('*');
    var out = '';

    for (var i = 0; i < chunks.length; i++) {
      out += i % 2 === 1 ? '<strong>' + chunks[i] + '</strong>' : chunks[i];
    }

    return out.split('[valor]').join('{{ }}');
  }

  // ---------------------------------------------------------------------------
  // Barras
  // ---------------------------------------------------------------------------

  /**
   * Reescreve mensagens, estado visual e threshold de UMA barra.
   *
   * A ordem importa: as mensagens NÃO estão em observedAttributes, então precisam já
   * estar no elemento quando o threshold mudar — é a mudança do threshold que dispara
   * o re-render. Reatribuir o mesmo threshold também dispara, o que é justamente como
   * forçamos o redesenho quando só a mensagem mudou.
   */
  function updateBar(bar, uf) {
    // O attributeChangedCallback do tema faz querySelector('progress-bar').
    // Sem o filho renderizado ele quebra, então pulamos elementos incompletos.
    if (!bar.querySelector('progress-bar')) return;

    var cents = Math.round(Number(uf.v) * 100);

    if (!(cents > 0)) return;

    var total = parseFloat(bar.getAttribute('total-price'));

    if (isNaN(total)) total = 0;

    var ratio = total / cents;
    var isComplete = total >= cents;
    var isAlmost = !isComplete && ratio >= config.almostAt;

    bar.classList.toggle('free-shipping-bar--complete', isComplete);
    bar.classList.toggle('free-shipping-bar--almost', isAlmost);

    // A barra da topbar tem o seletor ao lado; a da gaveta e a da página do carrinho
    // não têm. Lá a sigla precisa estar no próprio texto, senão o valor aparece sem
    // dizer a que estado se refere.
    var isTopbar = bar.hasAttribute('data-frete-regional');
    var reached = isTopbar ? config.msgReached : config.msgCartReached;
    var unreached = isAlmost
      ? (isTopbar ? config.msgAlmost : config.msgCartAlmost)
      : (isTopbar ? config.msgUnreached : config.msgCartUnreached);

    bar.setAttribute('reached-message', formatMessage(reached, uf.s));
    bar.setAttribute('unreached-message', formatMessage(unreached, uf.s));
    bar.setAttribute('threshold', cents);
  }

  function apply(uf) {
    if (!uf) return;

    currentUf = uf;
    isApplying = true;

    var bars = document.querySelectorAll('free-shipping-bar');

    for (var i = 0; i < bars.length; i++) {
      updateBar(bars[i], uf);
    }

    var selects = document.querySelectorAll('[data-frete-uf-select]');

    for (var j = 0; j < selects.length; j++) {
      selects[j].value = uf.s;
    }

    isApplying = false;
  }

  // ---------------------------------------------------------------------------
  // Nível 3 da cascata: IP
  // ---------------------------------------------------------------------------

  /**
   * Falha em silêncio, sempre. Serviço fora do ar, resposta lenta, país diferente,
   * sigla desconhecida ou operadora de celular: em todos esses casos a página
   * simplesmente segue com a UF padrão, que é o comportamento de quem não liga
   * esta opção. Nunca bloqueia render, nunca mostra erro.
   */
  function tentarPorIp() {
    if (!window.fetch || !window.Promise) return;

    var controller = null;

    try {
      controller = new AbortController();
    } catch (error) {
      controller = null;
    }

    var timer = setTimeout(function () {
      if (controller) controller.abort();
    }, IP_TIMEOUT_MS);

    window
      .fetch(IP_ENDPOINT, controller ? { signal: controller.signal } : {})
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        clearTimeout(timer);

        if (!data || data.success === false) return;
        if (data.country_code !== 'BR') return;

        var conexao = data.connection || {};
        var operadora = String(conexao.isp || '') + ' ' + String(conexao.org || '');

        if (OPERADORAS_MOVEIS.test(operadora)) return;

        var uf = ufByCode(data.region_code);

        if (!uf) return;

        // Chegou depois de o visitante escolher na mão: a escolha dele vence.
        var estado = readState();

        if (estado && estado.origem === 'manual') return;

        writeState(uf, 'ip');
        apply(uf);
      })
      .catch(function () {
        clearTimeout(timer);
      });
  }

  // ---------------------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------------------

  function boot() {
    var estado = readState();

    // 1. escolha manual
    if (estado && estado.origem === 'manual') {
      apply(estado.uf);
      return;
    }

    // 2. endereço do cliente logado
    var doCadastro = ufByCode(config.customerUf);

    if (doCadastro) {
      apply(doCadastro);
      writeState(doCadastro, 'cliente');
      return;
    }

    // 3. resultado de IP já em cache — evita uma chamada por página
    if (estado) {
      apply(estado.uf);
      return;
    }

    // 4. padrão, e só então tenta o IP
    apply(ufPadrao());

    if (config.ipEnabled) tentarPorIp();
  }

  // Troca manual no seletor. Delegado, porque o editor de temas recria a section.
  document.addEventListener('change', function (event) {
    var target = event.target;

    if (!target || !target.matches || !target.matches('[data-frete-uf-select]')) return;

    var uf = ufByCode(target.value);

    if (!uf) return;

    writeState(uf, 'manual');
    apply(uf);
  });

  /**
   * Um observer para dois problemas:
   *
   *   childList — a gaveta do carrinho é re-renderizada pelo tema a cada mudança, e o
   *   HTML novo volta com o threshold global do settings. Reaplicamos a UF.
   *
   *   total-price — é o atributo que o tema atualiza no evento 'cart:change'. Ele
   *   dispara o re-render da mensagem, mas o tema não sabe dos três estados; é aqui
   *   que decidimos entre padrão, "falta pouco" e o verde de atingido.
   *
   * Observamos 'total-price' e nunca 'threshold' de propósito: updateBar escreve
   * threshold, e observá-lo criaria um laço infinito.
   */
  var observer = new MutationObserver(function (mutations) {
    var barsToRefresh = [];

    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      if (mutation.type === 'attributes') {
        if (barsToRefresh.indexOf(mutation.target) === -1) barsToRefresh.push(mutation.target);
        continue;
      }

      if (isApplying) continue;

      var added = mutation.addedNodes;

      for (var j = 0; j < added.length; j++) {
        var node = added[j];

        if (node.nodeType !== 1) continue;

        if (
          node.tagName === 'FREE-SHIPPING-BAR' ||
          (node.querySelector && node.querySelector('free-shipping-bar'))
        ) {
          apply(currentUf || ufPadrao());
          return;
        }
      }
    }

    if (!barsToRefresh.length) return;

    var uf = currentUf || ufPadrao();

    for (var k = 0; k < barsToRefresh.length; k++) {
      updateBar(barsToRefresh[k], uf);
    }
  });

  function start() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['total-price']
    });

    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('free-shipping-bar').then(boot);
    } else {
      boot();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // O editor de temas recria sections sem recarregar a página.
  document.addEventListener('shopify:section:load', function () {
    apply(currentUf || ufPadrao());
  });
})();
